module.exports = __webpack_public_path__ + "static/Neue-Haas-Grotesk-Display-55-780acbeb828d5822f7a0b3609975a560.woff2";